/**
 * @generated SignedSource<<f21a4bba35a1e1992726eb370c3d0b3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery$variables = {};
export type DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery$data = {
  readonly deliveryOrderXlsxCreateFormat: string;
};
export type DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery = {
  response: DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery$data;
  variables: DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "deliveryOrderXlsxCreateFormat",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "517e81749181d29b30d8b48e070c363d",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery",
    "operationKind": "query",
    "text": "query DeliveryOrderXlsxCreateDialog_deliveryOrderXlsxCreateFormatQuery {\n  deliveryOrderXlsxCreateFormat\n}\n"
  }
};
})();

(node as any).hash = "d982d0b95325ef6ad654a7891cf52c02";

export default node;
